import { anonymousClient } from '../context/client_context'
import { CoinInfo } from '../context/coin_context'
import {
    CreditNoteInfo,
    DeliveryInfo,
    ParcelInfo,
    PaymentInSale,
    PreSaleInfo,
    ProductInDelivery,
    ProductInSale,
    SaleContract,
    SaleInfo,
    SaleReportsInfo,
    SoldProductsInfo,
} from '../context/sale_context'
import { SalesDocType } from '../pages/Sale/Home'
import { ListReturn } from '../utils/maks'
import { BranchApiData, parseBranch } from './branch'
import { BuyApiData, parseBuy } from './buy'
import { ClientApiData, parseClient } from './client'
import { DiscountApiData } from './discount'
import { EmployeeApiData, parseEmployee } from './employee'
import { get, post, put } from './generic'
import { NoteApiData, parseNote } from './note'
import {
    parseLoadLoteProduct,
    parseLoadSerialProduct,
    ParseProduct,
    ProductApiData,
    ProductInLoadLoteApiData,
    ProductInLoadSerialApiData,
} from './product'
import { parseSupplier, SupplierApiData } from './supplier'

export class CashierClosedSaleError extends Error {
    constructor() {
        super()
    }
}

export interface CreateSaleInterface {
    flag_forma_pagamento: number | null
    id_cliente?: number
    nota_entrega: string | null
    sale_product: {
        id_produto: number
        quantidade_produto: number
        desconto: number
        nome_preco?: string
        preco?: number
        id_produto_pre_venda?: number | null
    }[]
    sale_payment?: CreateSalePaymentInterface[] | null
    trocos?: {
        id_moeda: number
        valor: number
    }[]
    desconto: number | null
    desconto_credito: number | null
    use_legal_note?: boolean | null
    id_nota?: number | null
    id_moeda_fatura?: number | null
    tipo_transacao_fatura?: number
    id_filial_master?: number | null
    id_pre_venda?: number | null
    juros_inicial?: number
    id_funcionario?: number | null
    comissao?: number
    id_funcionario_pagamento?: number | null
    parcelas?: number[]
    isPix?: boolean
    isParaguayTransfer?: boolean
    id_guia?: number | null
    porcentagem_guia?: number
    id_moeda: number
}

export interface CreateSaleResponse {
    sale: SaleInfo
    pix: Pix | null
    paraguayTransfer: ParaguayTransfer | null
}

export interface UpdateSaleInterface {
    id_venda: number
    id_cliente?: number
    flag_forma_pagamento?: number | null
    flag_forma_pagamento_exibicao?: number | null
    use_legal_note?: boolean
    id_nota?: number | null
    id_moeda_fatura?: number | null
    tipo_transacao_fatura?: number
    id_funcionario?: number | null
    id_guia?: number | null
    data_vencimento?: string
    sale_product?: {
        id_produto: number
        quantidade_produto: number
        desconto: number
        nome_preco?: string
        preco?: number
        id_produto_pre_venda?: number | null
    }[]
    data_lancamento?: string
    hora_lancamento?: string
    nota_entrega?: string | null
    comissao?: number
    porcentagem_guia?: number
    numero_fatura_legal?: string | null
    data_faturamento?: string
    hora_faturamento?: string
    id_usuario?: number
}

export interface UpdateParcelInterface {
    id_parcela: number
    data_vencimento?: string
}

export interface FinalizePendingSaleInterface {
    id_venda: number
    flag_forma_pagamento: number | null
    sale_payment?: CreateSalePaymentInterface[] | null
    trocos: {
        id_moeda: number
        valor: number
    }[]
    desconto: number
    desconto_credito: number | null
    use_legal_note?: boolean | null
    id_nota?: number | null
    id_moeda_fatura?: number | null
    tipo_transacao_fatura?: number
    juros_inicial?: number
    parcelas?: number[]
    id_funcionario_pagamento?: number | null
    isPix?: boolean
    isParaguayTransfer?: boolean
}

export interface FinalizePendingSaleResponse {
    pix: Pix | null
    paraguayTransfer: ParaguayTransfer | null
}

export interface ListSalesInterface {
    skip?: number
    take?: number
    coins: CoinInfo[]
    id_cliente?: number[]
    id_caixa?: number[]
    id_usuario?: number[]
    id_funcionario?: number[]
    id_filial?: number[]
    search?: string
    status?: number[]
    data_inicial?: string
    data_final?: string
    id_caixa_historico?: number
    listErroredNotes?: boolean
    onlyLegalNote?: boolean
    onlyNonLegalNote?: boolean
}

export interface ListReportsInterface {
    coins: CoinInfo[]
    id_cliente?: number[]
    id_caixa?: number[]
    id_usuario?: number[]
    id_funcionario?: number[]
    id_filial?: number[]
    search?: string
    status?: number[]
    data_inicial?: string
    data_final?: string
    id_caixa_historico?: number
    listErroredNotes?: boolean
    onlyLegalNote?: boolean
    onlyNonLegalNote?: boolean
}

export interface GenerateSaleReportsInterface {
    id_cliente?: number[]
    id_caixa?: number[]
    id_usuario?: number[]
    id_funcionario?: number[]
    id_filial?: number[]
    search?: string
    status?: number[]
    data_inicial?: string
    data_final?: string
    id_caixa_historico?: number
    selectedFilters: Record<string, string>
    docType: SalesDocType
    listErroredNotes?: boolean
    onlyLegalNote?: boolean
    fieldsToShow?: any
    showDvInDocument?: boolean
    onlyNonLegalNote?: boolean
}

export interface ListSoldProductsInterface {
    skip?: number
    take?: number
    data_inicial?: string
    data_final?: string
    hora_inicial?: string
    productIds?: number[]
    id_cliente?: number[]
    id_grupo?: number[]
    id_sub_grupo?: number[]
    id_marca?: number[]
    id_modelo?: number[]
    id_fornecedor?: number[]
    order_by?: number
    selectedFilters?: Record<string, string>
    fieldsToShow?: any
    groupByClient?: boolean
}

interface ProductInSaleApiData {
    id_produto: number
    id_produto_venda: number
    id_venda: number
    preco_venda: string
    preco_fatura: string
    preco_compra: string
    preco_compra_base: string
    preco_unitario: string
    desconto: string
    produto: ProductApiData
    quantidade_produto: string
    valor_iva: string
    proporcao_iva: number | string | null
    id_desconto: number | null
    desconto_sistema: DiscountApiData
    preco_selecionado?: string
    data?: string
    hora?: string
    flag_horario_verao: number
    id_venda_anterior?: number
    vendaAnterior?: SaleApiData
    quantidade_devolvida: string
    quantidade_entregue: string
    id_produto_pre_venda: string | null
    valorMoedaSecundaria?: {
        iso_moeda: string
        id_moeda: number
        preco_venda: string
        preco_fatura: string
        preco_compra: string
        preco_compra_base: string
        preco_unitario: string
    }[]
    produtosEntrega?: ProductInDeliveryApiData[]
    produtoFatura: ProductApiData | null
}

interface SaleApiData {
    cliente: ClientApiData | null
    data_lancamento: string
    data_vencimento: string
    flag_forma_pagamento: number
    flag_forma_pagamento_exibicao: number
    hora_lancamento: string
    hora_vencimento: string
    id_cliente: number
    id_moeda: number
    id_usuario: number
    id_venda: number
    iva_5_porcento: string
    iva_10_porcento: string
    iva_total: string
    numero_caixa: number
    numero_fatura_legal: string
    juros_inicial: string
    produto_vendas: ProductInSaleApiData[]
    status_venda: number
    total_items: number
    valor_total: string
    valor_pago: string
    valor_juros: string
    valor_total_exento: string
    valor_total_5_porcento: string
    valor_total_10_porcento: string
    usuario: {
        nome: string
    }
    flag_horario_verao: number
    nota: NoteApiData | null
    filial: BranchApiData | null
    caixa: {
        id_caixa: number
        nome: string
    } | null
    nota_entrega: string | null
    pagamentos?: SalePaymentApiData[]
    cdc_fatura?: string
    qrcode?: string
    data_faturamento?: string
    hora_faturamento?: string
    flag_horario_verao_faturamento?: number
    funcionario: EmployeeApiData | null
    guia: EmployeeApiData | null
    status_fatura_eletronica?: number
    log_envio_fatura?: string
    flag_venda_juntada?: number
    notasCredito?: {
        notaCredito: CreditNoteApiData
    }[]
    id_filial?: number
    totalMoedaSecundaria?: {
        cambio: string
        iso_moeda: string
        id_moeda: number
        iva_5_porcento: string
        iva_10_porcento: string
        iva_total: string
        valor_total_exento: string
        valor_total_5_porcento: string
        valor_total_10_porcento: string
        valor_total: string
    }[]
    comissao: string
    porcentagem_guia: string
    numero_parcelas: number
    status_entrega: number
    id_pre_venda: number
}

export interface CreateSalePaymentInterface {
    id_moeda: number
    valor_pagamento: number
    id_metodo_pagamento: number
    comprovante_texto?: string
    comprovante_imagem?: string
    id_funcionario?: number | null
}

export interface CreateSalePaymentEndpointInterface {
    groupedPayments: {
        id_venda?: number | null
        id_parcela?: number | null
        payments: CreateSalePaymentInterface[]
        trocos: {
            id_moeda: number
            valor: number
        }[]
        desconto: number
        desconto_credito: number
    }[]
    id_funcionario_pagamento?: number | null
    isPix?: boolean
    isParaguayTransfer?: boolean
}

export interface CreateSalePaymentEndpointResponse {
    payments: PaymentInSale[]
    pix: Pix | null
    paraguayTransfer: ParaguayTransfer | null
}

export interface SalePaymentApiData {
    data_lancamento: string
    hora_lancamento: string
    id_cliente: number
    id_moeda: number
    id_usuario: number
    id_venda: number
    id_venda_pagamento: number
    valor_pagamento: string
    desconto: string
    desconto_credito: string
    valor_moeda_secundaria: string
    flag_cambio_reverso: number | null
    cambio: string
    caixa: {
        id_caixa: number
        nome: string
    } | null
    usuario: {
        nome: string
    } | null
    id_metodo_pagamento: number
    metodoPagamento: {
        nome: string
        flag_ativo: number
    }
    comprovante_texto: string | null
    comprovante_imagem: string | null
    flag_horario_verao: number
    status_pagamento: number
    entrada_total: string
    funcionario: EmployeeApiData | null
    numero_fatura: string
    nota: NoteApiData | null
    data_faturamento?: string
    hora_faturamento?: string
    flag_horario_verao_faturamento?: number
    venda?: SaleApiData
    flag_pagamento_juntado: number
    pagamentosAnteriores?: {
        pagamentoAnterior: SalePaymentApiData
    }[]
    valor_juros_pagos: string
    trocos?: {
        id_troco_pagamento: number
        id_venda_pagamento: number
        id_moeda: number
        valor: string
    }[]
}

export interface SoldProductsApiData {
    productId: number
    product: string
    averageBuyPrice: string
    averageBuyPriceBase: string
    averageSalePrice: string
    averageGain: string
    averageGainBase: string
    averageDiscount: string
    qntSold: string
    qntSales: string
    coinId: number
    clientName?: string
}

export interface CreatePreSaleInterface {
    titulo: string
    produtos: {
        id_produto: number
        quantidade_produto: number
        preco_selecionado?: string
        desconto?: number
    }[]
    flag_ativo: number
    anotacao: string | null
    id_cliente: number | null
    id_filial_master?: number | null
    id_funcionario?: number | null
    id_moeda: number
    flag_reservar_estoque: number
}

export interface UpdatePreSaleInterface
    extends Partial<CreatePreSaleInterface> {
    id_pre_venda: number
}

interface PreSaleApiData {
    id_pre_venda: number
    titulo: string
    data: string
    hora: string
    id_caixa: number
    id_usuario: number
    flag_horario_verao: number
    flag_ativo: number
    cliente: ClientApiData | null
    anotacao: string | null
    id_filial: number | null
    caixa: {
        id_caixa: number
        nome: string
    } | null
    usuario: {
        nome: string
    } | null
    produtosPreVenda: {
        id_produto_pre_venda: number
        id_produto: number
        produto: ProductApiData
        quantidade_produto: string
        quantidade_produto_vendido: string
        desconto: string
        preco_venda: string
        preco_fatura: string
        preco_selecionado?: string
    }[]
    valor_total: string
    id_moeda: number
    filial: BranchApiData | null
    id_funcionario: number | null
    funcionario: EmployeeApiData | null
    flag_reservar_estoque: number
}

export interface ListPreSalesInterface {
    search?: string
    skip?: number
    take?: number
    flag_ativo?: number
    id_cliente?: number[]
    id_funcionario?: number[]
    id_filial?: number[]
    data_inicial?: string
    data_final?: string
}

export interface ParcelApiData {
    id_parcela: number
    valor_total: string
    valor_pago: string
    valor_juros: string
    status_parcela: number
    id_venda: number
    numero_parcela: number
    data_vencimento: string | null
    hora_vencimento: string | null
    pagamentos: SalePaymentApiData[]
    numero_fatura_legal?: string | null
    cdc_fatura?: string | null
    qrcode?: string | null
    status_fatura_eletronica?: number
    id_nota?: number | null
    id_moeda_fatura_eletronica?: number | null
    tipo_transacao_fatura?: number
    log_envio_fatura?: string | null
    nota?: {
        id_nota: number
        timbrado: number
        prefixo_nota: string
        data_inicial: string
        data_final: string | null
    } | null
}

export interface ListParcelsInterface {
    id_venda?: number
    id_filial?: number[]
    skip?: number
    take?: number
}

export interface CreateCreditNote {
    id_operacoes: number[]
    flag_tipo_nota_credito: number
    produtos: {
        id_produto: number
        quantidade: number
        preco: number
        id_produto_operacao?: number | null
    }[]
    changeStock?: boolean
    id_cliente?: number
    id_fornecedor?: number
    id_filial_master?: number
    valor_desconto?: number
    flag_devolveu_saldo_extra?: number
}

export interface CancelCreditNote {
    id_nota_credito: number
}

export interface UpdateCreditNote {
    id_nota_credito: number
    use_legal_note?: boolean
    numero_fatura?: string
}

export interface FindCreditNote {
    id_venda?: number
    id_compra?: number
    skip?: number
    take?: number
    loadFullRelations?: boolean
}

export interface CreditNoteApiData {
    id_nota_credito: number
    data: string
    hora: string
    id_usuario: number
    id_venda: number
    iva_5_porcento: string
    iva_10_porcento: string
    iva_total: string
    numero_fatura: string
    produtosNotaCredito: {
        id_produto_nota_credito: number
        quantidade_produto: string
        preco: string
        preco_unitario: string
        valor_iva: string
        proporcao_iva: number | string | null
        produto: ProductApiData
    }[]
    total_items: number
    valor_total: string
    valor_total_exento: string
    valor_total_5_porcento: string
    valor_total_10_porcento: string
    usuario: {
        nome: string
    }
    flag_horario_verao: number
    flag_tipo_nota_credito: number
    flag_status: number
    nota: NoteApiData | null
    caixa: {
        id_caixa: number
        nome: string
    } | null
    cdc_fatura?: string
    qrcode?: string
    status_fatura_eletronica?: number
    log_envio_fatura?: string
    data_faturamento?: string
    hora_faturamento?: string
    flag_horario_verao_faturamento?: number
    id_moeda?: number
    operacoes?: {
        venda?: SaleApiData
        compra?: BuyApiData
    }[]
    filial: BranchApiData | null
    cliente: ClientApiData | null
    fornecedor: SupplierApiData | null
    flag_nota_debito: number
    flag_modificou_estoque: number
    valor_desconto: string
    flag_devolveu_saldo_extra: number
}

export interface UpdateSalePaymentSale {
    id_venda_pagamento: number
    id_funcionario?: number | null
    use_legal_note?: boolean
}

export interface JoinSales {
    id_venda: number[]
}

export interface JoinPayments {
    id_venda_pagamento: number[]
}

export interface FixEletronicNote {
    id_venda?: number
    id_nota_credito?: number
    id_transferencia_estoque?: number
}

export interface ListSalePayments {
    id_venda?: number[]
    skip?: number
    take?: number
    search?: string
    status?: number[]
    data_inicial?: string
    data_final?: string
    id_cliente?: number[]
    id_filial?: number[]
    onlyLegalNote?: boolean
    selectedFilters?: Record<string, string>
}

export enum PixStatusEnum {
    Pending = 0,
    Paid = 1,
    Refunded = 2,
    Expired = 3,
    RefundInProgress = 4,
}

export const PixStatusLabel: Record<number, string> = {
    0: 'Pendiente',
    1: 'Pago',
    2: 'Devolvido',
    3: 'Expirado',
    4: 'Devolución em processo',
}

export interface Pix {
    id_pix: number
    valor: number
    flag_status: number
    data_cadastro: Date
    data_pagamento?: Date | null
    data_expiracao?: Date | null
    externalId?: string | null
    qrcode?: string | null
    flag_liquidado: number
    valor_moeda_principal: number
    cambio_moeda_principal: number
    cambio_final_moeda_principal: number
    flag_cambio_reverso_moeda_principal: number
    id_moeda_principal: number
}

export interface ListPix {
    skip?: number
    take?: number
    flag_status?: number
    flag_liquidado?: number
}

export enum ParaguayTransferStatusEnum {
    Pending = 0,
    Paid = 1,
    Refunded = 2,
    Expired = 3,
}

export interface ParaguayTransfer {
    id_transferencia_paraguai: number
    valor: number
    flag_status: number
    data_cadastro: Date
    data_pagamento?: Date | null
    data_expiracao?: Date | null
    data_liquidacao?: Date | null
    externalId?: string | null
}

export interface ListSalePaymentReportsOutput {
    coinId: number
    saleCoinId: number
    totalPayed: number
    totalPayedSecondaryCoin: number
    totalEntry: number
    totalChange: number
    totalChangeSecondaryCoin: number
    totalComission: number
}

export interface SaleContractApiData {
    id_pagare: number
    id_cliente: number
    id_moeda: number
    id_venda?: number | null
    id_parcela?: number | null
    valor: string
    data: string
    hora: string
    flag_horario_verao: number
    data_vencimento: string
    hora_vencimento: string
    venda?: SaleApiData | null
    parcela?: ParcelApiData | null
    cliente?: ClientApiData | null
    filial?: BranchApiData | null
}

export interface ListSaleContractsInterface {
    skip?: number
    take?: number
}

export interface CreateSaleContractsInterface {
    id_cliente: number
    id_moeda: number
    data_vencimento: string
    valor: number
    id_filial_master?: number | null
}

export interface UpdateSaleProduct {
    id_produto_venda: number
}

export interface CreateDeliveryInterface {
    id_venda: number
    produtos: {
        id_produto_venda: number
        quantidade: number
        id_produto_serial?: number
        serial?: string
        id_produto_lote?: number
        lote?: string
    }[]
}

export interface RefundProductsInDeliveryInterface {
    id_produto_entrega: number[]
}

export interface ProductInDeliveryApiData {
    id_produto_entrega: number
    id_entrega: number
    id_produto: number
    id_produto_venda: number
    quantidade_produto: string
    produto?: ProductApiData
    produtoSerial?: ProductInLoadSerialApiData
    serial?: string | null
    produtoLote?: ProductInLoadLoteApiData
    lote?: string | null
    quantidade_devolvida: string
    produtoVenda?: ProductInSaleApiData
}

export interface DeliveryApiData {
    id_entrega: number
    id_usuario: number
    id_caixa: number
    id_venda: number
    data: string
    hora: string
    flag_horario_verao: number
    produtosEntrega: ProductInDeliveryApiData[]
    venda?: SaleApiData
    caixa: {
        id_caixa: number
        nome: string
    } | null
    usuario: {
        nome: string
    } | null
}

export interface ListDeliveryInterface {
    skip?: number
    take?: number
    id_venda?: number
    search?: string
}

function parseSaleProduct(
    p: ProductInSaleApiData,
    coins: CoinInfo[]
): ProductInSale {
    return {
        id: p.id_produto_venda,
        price: Number(p.preco_venda),
        notePrice: Number(p.preco_fatura),
        unitPrice: Number(p.preco_unitario),
        qnt: Number(p.quantidade_produto),
        subtotal: Number(p.preco_fatura) * Number(p.quantidade_produto),
        product: p.produto
            ? ParseProduct(p.produto, coins)
            : (undefined as any),
        discount: Number(p.desconto),
        buyPrice: Number(p.preco_compra),
        baseBuyPrice: Number(p.preco_compra_base),
        ivaValue: Number(p.valor_iva),
        proporcaoIva:
            Number(p.proporcao_iva) > 0
                ? Number(p.proporcao_iva)
                : 100,
        systemDiscount: p.id_desconto
            ? {
                  id: p.desconto_sistema.id_desconto,
                  title: p.desconto_sistema.titulo,
              }
            : null,
        selectedNamedPrice: p.preco_selecionado,
        date: p.data,
        hour: p.hora,
        isSummerTime: Boolean(p.flag_horario_verao),
        prevSaleId: p.id_venda_anterior,
        prevSale: p.vendaAnterior
            ? parseSale(p.vendaAnterior, coins)
            : undefined,
        returnedQnt: Number(p.quantidade_devolvida),
        deliveredQnt: Number(p.quantidade_entregue),
        valueSecondaryCoin: p.valorMoedaSecundaria
            ? p.valorMoedaSecundaria.map((v) => ({
                  iso: v.iso_moeda,
                  coinId: v.id_moeda,
                  buyPrice: Number(v.preco_compra),
                  baseBuyPrice: Number(v.preco_compra_base),
                  price: Number(v.preco_venda),
                  notePrice: Number(v.preco_fatura),
                  unitPrice: Number(v.preco_unitario),
              }))
            : [],
        productsInDelivery: p.produtosEntrega
            ? p.produtosEntrega.map((pe) => parseProductInDelivery(pe, coins))
            : undefined,
        saleId: p.id_venda,
        noteProduct: p.produtoFatura
            ? ParseProduct(p.produtoFatura, coins)
            : null,
        preSaleProductId: p.id_produto_pre_venda ? Number(p.id_produto_pre_venda) : undefined,
    }
}

function parseSale(data: SaleApiData, coins: CoinInfo[]): SaleInfo {
    return {
        bill: data.numero_fatura_legal,
        client: data.cliente
            ? parseClient(data.cliente, coins)
            : anonymousClient,
        observation: data.nota_entrega ? data.nota_entrega : '',
        payments: data.pagamentos
            ? data.pagamentos.map((pagamento) => parseSalePayment(pagamento, coins))
            : [],
        paymentType: data.flag_forma_pagamento,
        paymentTypeShow: data.flag_forma_pagamento_exibicao,
        coin: coins?.filter((c) => c.id === data.id_moeda)[0],
        total: Number(data.valor_total),
        totalIva: Number(data.iva_total),
        totalIvaFivePercent: Number(data.iva_5_porcento),
        totalIvaTenPercent: Number(data.iva_10_porcento),
        totalAmoutPayed: Number(data.valor_pago),
        totalFees: Number(data.valor_juros),
        totalExcept: Number(data.valor_total_exento),
        totalFivePercent: Number(data.valor_total_5_porcento),
        totalTenPercent: Number(data.valor_total_10_porcento),
        date: data.data_lancamento,
        hour: data.hora_lancamento,
        expDate: data.data_vencimento,
        expHour: data.hora_vencimento,
        id: data.id_venda,
        initialFees: Number(data.juros_inicial),
        products:
            data.produto_vendas?.map((p) => parseSaleProduct(p, coins)) ?? [],
        saleStatus: data.status_venda,
        cashier: data.caixa
            ? {
                  id: data.caixa.id_caixa,
                  hash: '',
                  name: data.caixa.nome,
                  isActive: false,
                  branch: null,
              }
            : undefined,
        account: data.usuario
            ? {
                  id: 0,
                  name: data.usuario.nome,
                  username: '',
                  password: '',
                  cpassword: '',
                  rules: [],
                  isMaster: false,
                  isActive: false,
                  loginWithImage: false,
                  image: null,
                  branch: null,
              }
            : undefined,
        isSummerTime: Boolean(data.flag_horario_verao),
        note: data.nota ? parseNote(data.nota) : null,
        branch: data.filial ? parseBranch(data.filial) : null,
        cdc: data.cdc_fatura,
        qrCode: data.qrcode,
        noteDate: data.data_faturamento,
        noteHour: data.hora_faturamento,
        isNoteSummerTime: Boolean(data.flag_horario_verao_faturamento),
        employee: data.funcionario
            ? parseEmployee(data.funcionario, coins)
            : undefined,
        guide: data.guia ? parseEmployee(data.guia, coins) : undefined,
        statusEletronicNote: data.status_fatura_eletronica,
        logEletronicNote: data.log_envio_fatura,
        creditNotes: data.notasCredito
            ? data.notasCredito.map((nc) =>
                  parseCreditNote(nc.notaCredito, coins)
              )
            : undefined,
        isJoinedNote: Boolean(data.flag_venda_juntada),
        branchId: data.id_filial,
        totalSecondaryCoin: data.totalMoedaSecundaria
            ? data.totalMoedaSecundaria.map((t) => ({
                  exchange: Number(t.cambio),
                  iso: t.iso_moeda,
                  coinId: t.id_moeda,
                  totalIvaFivePercent: Number(t.iva_5_porcento),
                  totalIvaTenPercent: Number(t.iva_10_porcento),
                  totalIva: Number(t.iva_total),
                  totalExcept: Number(t.valor_total_exento),
                  totalFivePercent: Number(t.valor_total_5_porcento),
                  totalTenPercent: Number(t.valor_total_10_porcento),
                  total: Number(t.valor_total),
              }))
            : [],
        comission: Number(data.comissao),
        guidePercentage: Number(data.porcentagem_guia),
        totalParcels: data.numero_parcelas,
        deliveryStatus: data.status_entrega,
        preSaleId: data.id_pre_venda,
    }
}

function parseSalePayment(
    data: SalePaymentApiData,
    coins?: CoinInfo[]
): PaymentInSale {
    return {
        id: data.id_venda_pagamento,
        amountPayed: Number(data.valor_pagamento),
        discount: Number(data.desconto),
        creditDiscount: Number(data.desconto_credito),
        paymentCoin: coins?.find((c) => c.id === data.id_moeda) ?? null,
        paymentMethod: data.metodoPagamento
            ? {
                  id: data.id_metodo_pagamento,
                  name: data.metodoPagamento.nome,
                  isActive: Boolean(data.metodoPagamento.flag_ativo),
              }
            : null,
        exchange: Number(data.cambio)
            ? {
                  exchangeValue: Number(data.cambio),
                  exchangeAmountPayed: Number(data.valor_moeda_secundaria),
                  flagReverseExchange: data.flag_cambio_reverso ?? 0,
              }
            : undefined,
        date: data.data_lancamento,
        hour: data.hora_lancamento,
        cashier: data.caixa
            ? {
                  id: data.caixa.id_caixa,
                  hash: '',
                  name: data.caixa.nome,
                  isActive: false,
                  branch: null,
              }
            : undefined,
        madeBy: data.usuario
            ? {
                  id: 0,
                  name: data.usuario.nome,
                  username: '',
                  password: '',
                  cpassword: '',
                  rules: [],
                  isMaster: false,
                  isActive: false,
                  loginWithImage: false,
                  image: null,
                  branch: null,
              }
            : null,
        proofText: data.comprovante_texto ?? undefined,
        proofImage: data.comprovante_imagem ?? undefined,
        isSummerTime: Boolean(data.flag_horario_verao),
        paymentStatus: data.status_pagamento,
        bill: data.numero_fatura,
        note: data.nota ? parseNote(data.nota) : null,
        noteDate: data.data_faturamento,
        noteHour: data.hora_faturamento,
        isNoteSummerTime: Boolean(data.flag_horario_verao_faturamento),
        employee: data.funcionario
            ? parseEmployee(data.funcionario, coins)
            : undefined,
        sale: data.venda && coins ? parseSale(data.venda, coins) : undefined,
        isJoinedPayment: Boolean(data.flag_pagamento_juntado),
        prevPayments: data.pagamentosAnteriores
            ? data.pagamentosAnteriores.map((p) =>
                  parseSalePayment(p.pagamentoAnterior, coins)
              )
            : undefined,
        feesPayed: Number(data.valor_juros_pagos),
        changes: data.trocos?.map((troco) => ({
            coin: coins?.find((c) => c.id === troco.id_moeda) as CoinInfo,
            value: Number(troco.valor),
        })) ?? [],
    }
}

function parseSaleReport(
    data: SaleReportsInfo,
    coins: CoinInfo[]
): SaleReportsInfo {
    return {
        ...data,
        coin: coins.find((c) => c.id === data.coinId),
    }
}

function parseSoldProducts(
    data: SoldProductsApiData,
    coins: CoinInfo[]
): SoldProductsInfo {
    return {
        ...data,
        coin: coins.find((c) => c.id === data.coinId),
    }
}

function parsePreSale(data: PreSaleApiData, coins: CoinInfo[]): PreSaleInfo {
    return {
        id: data.id_pre_venda,
        title: data.titulo,
        products:
            data.produtosPreVenda?.map((p, i) => {
                const product = ParseProduct(p.produto, coins)

                return {
                    id: p.id_produto_pre_venda,
                    product: product,
                    qnt: Number(p.quantidade_produto),
                    soldQnt: Number(p.quantidade_produto_vendido),
                    price: Number(p.preco_venda),
                    notePrice: Number(p.preco_fatura),
                    subtotal:
                        Number(p.preco_fatura) * Number(p.quantidade_produto),
                    discount: Number(p.desconto) * 100,
                    selectedNamedPrice: p.preco_selecionado,
                }
            }) ?? [],
        branch: data.filial ? parseBranch(data.filial) : null,
        total: Number(data.valor_total),
        totalIva: 0,
        client: data.cliente
            ? parseClient(data.cliente, coins)
            : anonymousClient,
        annotation: data.anotacao,
        cashier: data.caixa
            ? {
                  id: data.caixa.id_caixa,
                  hash: '',
                  name: data.caixa.nome,
                  isActive: false,
                  branch: null,
              }
            : undefined,
        account: data.usuario
            ? {
                  id: 0,
                  name: data.usuario.nome,
                  username: '',
                  password: '',
                  cpassword: '',
                  rules: [],
                  isMaster: false,
                  isActive: false,
                  loginWithImage: false,
                  image: null,
                  branch: null,
              }
            : undefined,
        date: data.data,
        hour: data.hora,
        isSummerTime: Boolean(data.flag_horario_verao),
        isActive: Boolean(data.flag_ativo),
        productCount:
            data.produtosPreVenda?.[data.produtosPreVenda.length - 1]
                .id_produto_pre_venda ?? 0,
        employee: data.funcionario
            ? parseEmployee(data.funcionario, coins)
            : null,
        coin: coins.find((c) => c.id === data.id_moeda),
        reservedStock: Boolean(data.flag_reservar_estoque),
    }
}

export function parseParcel(data: ParcelApiData): ParcelInfo {
    return {
        id: data.id_parcela,
        saleId: data.id_venda,
        endDate: data.data_vencimento as string,
        endHour: data.hora_vencimento as string,
        status: data.status_parcela,
        total: Number(data.valor_total),
        totalPaid: Number(data.valor_pago),
        totalFees: Number(data.valor_juros),
        payments: data.pagamentos?.map((pagamento) =>
            parseSalePayment(pagamento)
        ),
        parcelNumber: data.numero_parcela,
        numeroFaturaLegal: data.numero_fatura_legal ?? null,
        cdc: data.cdc_fatura ?? null,
        qrCode: data.qrcode ?? null,
        statusEletronicNote: data.status_fatura_eletronica ?? 0,
        logEletronicNote: data.log_envio_fatura ?? null,
        noteTimbrado: data.nota?.timbrado ?? null,
        notePrefix: data.nota?.prefixo_nota ?? null,
        noteIniD: data.nota?.data_inicial ?? null,
        noteEndD: data.nota?.data_final ?? null,
        notaId: data.id_nota ?? null,
        noteCoinId: data.id_moeda_fatura_eletronica ?? null,
        transactionType: data.tipo_transacao_fatura ?? 1,
    }
}

export function parseCreditNote(
    data: CreditNoteApiData,
    coins: CoinInfo[]
): CreditNoteInfo {
    return {
        bill: data.numero_fatura,
        total: Number(data.valor_total),
        totalIva: Number(data.iva_total),
        totalIvaFivePercent: Number(data.iva_5_porcento),
        totalIvaTenPercent: Number(data.iva_10_porcento),
        totalExcept: Number(data.valor_total_exento),
        totalFivePercent: Number(data.valor_total_5_porcento),
        totalTenPercent: Number(data.valor_total_10_porcento),
        date: data.data,
        hour: data.hora,
        id: data.id_nota_credito,
        products:
            data.produtosNotaCredito?.map((p) => ({
                id: p.id_produto_nota_credito,
                qnt: Number(p.quantidade_produto),
                price: Number(p.preco),
                ivaValue: Number(p.valor_iva),
                proporcaoIva:
                    Number(p.proporcao_iva) > 0
                        ? Number(p.proporcao_iva)
                        : 100,
                unitPrice: Number(p.preco_unitario),
                subtotal: Number(p.preco) * Number(p.quantidade_produto),
                product: ParseProduct(p.produto, coins),
            })) ?? [],
        cashier: data.caixa
            ? {
                  id: data.caixa.id_caixa,
                  name: data.caixa.nome,
              }
            : undefined,
        account: data.usuario
            ? {
                  name: data.usuario.nome,
              }
            : undefined,
        isSummerTime: Boolean(data.flag_horario_verao),
        note: data.nota ? parseNote(data.nota) : null,
        cdc: data.cdc_fatura,
        qrCode: data.qrcode,
        statusEletronicNote: data.status_fatura_eletronica,
        logEletronicNote: data.log_envio_fatura,
        noteDate: data.data_faturamento,
        noteHour: data.hora_faturamento,
        isNoteSummerTime: Boolean(data.flag_horario_verao_faturamento),
        type: data.flag_tipo_nota_credito,
        status: data.flag_status,
        operations: data.operacoes
            ? data.operacoes.map((o) => ({
                  sale: o.venda ? parseSale(o.venda, coins) : undefined,
                  buy: o.compra ? parseBuy(o.compra, coins) : undefined,
              }))
            : undefined,
        coin: coins?.find((c) => c.id === data.id_moeda) ?? undefined,
        branch: data.filial ? parseBranch(data.filial) : undefined,
        client: data.cliente ? parseClient(data.cliente, coins) : undefined,
        supplier: data.fornecedor
            ? parseSupplier(data.fornecedor, coins)
            : undefined,
        isDebitNote: Boolean(data.flag_nota_debito),
        changedStock: Boolean(data.flag_modificou_estoque),
        discount: Number(data.valor_desconto),
        refundedWithExtraCredit: Boolean(data.flag_devolveu_saldo_extra),
    }
}

export function parseSaleContract(
    data: SaleContractApiData,
    coins: CoinInfo[]
): SaleContract {
    return {
        id: data.id_pagare,
        date: data.data,
        hour: data.hora,
        isSummerTime: Boolean(data.flag_horario_verao),
        value: Number(data.valor),
        expDate: data.data_vencimento,
        expHour: data.hora_vencimento,
        sale: data.venda ? parseSale(data.venda, coins) : null,
        parcel: data.parcela ? parseParcel(data.parcela) : null,
        client: data.cliente ? parseClient(data.cliente, coins) : null,
        branch: data.filial ? parseBranch(data.filial) : null,
        coin: coins.find((c) => c.id === data.id_moeda),
    }
}

export function parseProductInDelivery(
    p: ProductInDeliveryApiData,
    coins: CoinInfo[]
): ProductInDelivery {
    console.log(p)
    return {
        id: p.id_produto_entrega,
        qnt: Number(p.quantidade_produto),
        product: p.produto ? ParseProduct(p.produto, coins) : undefined,
        productSerial: p.produtoSerial
            ? parseLoadSerialProduct(p.produtoSerial)
            : undefined,
        serial: p.serial,
        productLote: p.produtoLote
            ? parseLoadLoteProduct(p.produtoLote)
            : undefined,
        lote: p.lote,
        refundedQnt: Number(p.quantidade_devolvida),
        productSale: p.produtoVenda
            ? parseSaleProduct(p.produtoVenda, coins)
            : undefined,
    }
}

export function parseDelivery(
    data: DeliveryApiData,
    coins: CoinInfo[]
): DeliveryInfo {
    return {
        id: data.id_entrega,
        cashier: data.caixa
            ? {
                  id: data.caixa.id_caixa,
                  name: data.caixa.nome,
              }
            : undefined,
        account: data.usuario
            ? {
                  name: data.usuario.nome,
              }
            : undefined,
        date: data.data,
        hour: data.hora,
        isSummerTime: Boolean(data.flag_horario_verao),
        sale: data.venda ? parseSale(data.venda, coins) : undefined,
        products: data.produtosEntrega.map((pe) =>
            parseProductInDelivery(pe, coins)
        ),
    }
}

export async function createSale(
    data: CreateSaleInterface,
    coins: CoinInfo[]
): Promise<CreateSaleResponse> {
    try {
        const res = await post('sale', data, {
            useRecaptcha: false,
        })
        return {
            sale: parseSale(res.data.data.sale, coins),
            pix: res.data.data.pix,
            paraguayTransfer: res.data.data.paraguayTransfer,
        }
    } catch (error: any) {
        if (error?.message === 'Cashier is not open')
            throw new CashierClosedSaleError()
        throw error
    }
}

export async function updateSale(data: UpdateSaleInterface): Promise<void> {
    await put('sale', data, {
        useRecaptcha: true,
    })
}

export async function finalizePendingSale(
    data: FinalizePendingSaleInterface
): Promise<FinalizePendingSaleResponse> {
    try {
        const res = await post('sale/finalize', data, {
            useRecaptcha: false,
        })
        return {
            pix: res.data.data.pix,
            paraguayTransfer: res.data.data.paraguayTransfer,
        }
    } catch (error: any) {
        if (error?.message === 'Cashier is not open')
            throw new CashierClosedSaleError()
        throw error
    }
}

export async function getSaleById(
    saleId: number,
    coins: CoinInfo[]
): Promise<SaleInfo> {
    const res = await post(`sale/specific`, { id_venda: saleId })
    return parseSale(res.data.data.sale, coins)
}

export async function listSales(
    data: ListSalesInterface
): Promise<ListReturn<SaleInfo>> {
    const res = await post('sale/list', {
        ...data,
        coins: undefined,
    })
    return {
        data: res.data.data.data.map((apiData: SaleApiData) =>
            parseSale(apiData, data.coins)
        ),
        count: res.data.data.count,
    }
}

export async function listSaleProducts(
    id_venda: number,
    coins: CoinInfo[]
): Promise<ProductInSale[]> {
    const res = await get(`sale-products/${id_venda}`)
    return res.data.data.map((apiData: ProductInSaleApiData) =>
        parseSaleProduct(apiData, coins)
    )
}

export async function cancelSale(saleId: number): Promise<void> {
    await post(
        `sale/cancel`,
        { id_venda: saleId },
        {
            useRecaptcha: true,
        }
    )
}

export async function listSaleReports(
    data: ListReportsInterface
): Promise<SaleReportsInfo[]> {
    const res = await post('reports/sale', data)

    return res.data.data.map((apiData: SaleReportsInfo) =>
        parseSaleReport(apiData, data.coins)
    )
}

export async function generateSaleReports(
    data: GenerateSaleReportsInterface
): Promise<void> {
    await post('reports/sale/generate', data, {
        useRecaptcha: true,
    })
}

export async function createSalePayment(
    data: CreateSalePaymentEndpointInterface,
    coins: CoinInfo[]
): Promise<CreateSalePaymentEndpointResponse> {
    try {
        const res = await post('sale-payment', data, {
            useRecaptcha: true,
        })

        return {
            payments: res.data.data.payments.map((data: SalePaymentApiData) =>
                parseSalePayment(data, coins)
            ),
            pix: res.data.data.pix,
            paraguayTransfer: res.data.data.paraguayTransfer,
        }
    } catch (error: any) {
        if (error?.message === 'Cashier is not open')
            throw new CashierClosedSaleError()
        throw error
    }
}

export async function listSalePayments(
    data: ListSalePayments,
    coins?: CoinInfo[]
): Promise<ListReturn<PaymentInSale>> {
    const res = await post('sale-payments', data)
    return {
        data: res.data.data.data.map((p: SalePaymentApiData) =>
            parseSalePayment(p, coins)
        ),
        count: res.data.data.count,
    }
}

export async function listSalePaymentsReports(
    data: ListSalePayments
): Promise<ListSalePaymentReportsOutput[]> {
    const res = await post('sale-payments/reports', data)
    return res.data.data
}

export async function generateSalePaymentsReports(
    data: ListSalePayments
): Promise<ListSalePaymentReportsOutput[]> {
    const res = await post('sale-payments/reports/generate', data, {
        useRecaptcha: true,
    })
    return res.data.data
}

export async function listSoldProducts(
    data: ListSoldProductsInterface,
    coins: CoinInfo[]
): Promise<SoldProductsInfo[]> {
    const res = await post('reports/sold-products', data)
    return res.data.data.map((data: SoldProductsApiData) =>
        parseSoldProducts(data, coins)
    )
}

export async function generateSoldProducts(
    data: ListSoldProductsInterface
): Promise<void> {
    await post('reports/sold-products/generate', data, {
        useRecaptcha: true,
    })
}

export async function cancelSalePayment(salePaymentId: number): Promise<void> {
    await post(
        `sale-payment/cancel`,
        { id_venda_pagamento: salePaymentId },
        {
            useRecaptcha: true,
        }
    )
}

export async function updateSalePayment(
    data: UpdateSalePaymentSale
): Promise<void> {
    await put(`sale-payment`, data, {
        useRecaptcha: true,
    })
}

export async function createPreSale(
    data: CreatePreSaleInterface,
    coins: CoinInfo[]
): Promise<PreSaleInfo> {
    try {
        const res = await post('pre-sale', data, {
            useRecaptcha: true,
        })

        return parsePreSale(res.data.data, coins)
    } catch (error: any) {
        if (error?.message === 'Cashier is not open')
            throw new CashierClosedSaleError()
        throw error
    }
}

export async function updatePreSale(
    data: UpdatePreSaleInterface,
    coins: CoinInfo[]
): Promise<PreSaleInfo> {
    try {
        const res = await put('pre-sale', data, {
            useRecaptcha: true,
        })

        return parsePreSale(res.data.data, coins)
    } catch (error: any) {
        if (error?.message === 'Cashier is not open')
            throw new CashierClosedSaleError()
        throw error
    }
}

export async function listPreSales(
    data: ListPreSalesInterface,
    coins: CoinInfo[]
): Promise<ListReturn<PreSaleInfo>> {
    const res = await post('pre-sales', data)
    return {
        data: res.data.data.data.map((preSaleApiData: PreSaleApiData) =>
            parsePreSale(preSaleApiData, coins)
        ),
        count: res.data.data.count,
    }
}

export async function getPreSaleById(
    id: number,
    coins: CoinInfo[]
): Promise<PreSaleInfo> {
    const res = await get(`pre-sale/${id}`)
    return parsePreSale(res.data.data, coins)
}

export async function listParcels(
    data: ListParcelsInterface
): Promise<ParcelInfo[]> {
    const res = await post('parcels', data)
    return res.data.data.map((parcel: any) => parseParcel(parcel))
}

export async function createCreditNote(data: CreateCreditNote): Promise<void> {
    try {
        await post('credit-note', data, {
            useRecaptcha: true,
        })
    } catch (error: any) {
        if (error?.message === 'Cashier is not open')
            throw new CashierClosedSaleError()
        throw error
    }
}

export async function cancelCreditNote(data: CancelCreditNote): Promise<void> {
    try {
        await post('credit-note/cancel', data, {
            useRecaptcha: true,
        })
    } catch (error: any) {
        if (error?.message === 'Cashier is not open')
            throw new CashierClosedSaleError()
        throw error
    }
}

export async function updateCreditNote(data: UpdateCreditNote): Promise<void> {
    try {
        await put('credit-note', data, {
            useRecaptcha: true,
        })
    } catch (error: any) {
        if (error?.message === 'Cashier is not open')
            throw new CashierClosedSaleError()
        throw error
    }
}

export async function findCreditNote(
    data: FindCreditNote,
    coins: CoinInfo[]
): Promise<ListReturn<CreditNoteInfo>> {
    const res = await post(`credit-note/list`, data)
    return {
        count: res.data.data.count,
        data: res.data.data.data.map((creditNote: CreditNoteApiData) =>
            parseCreditNote(creditNote, coins)
        ),
    }
}

export async function findCreditNoteById(
    id: number,
    coins: CoinInfo[]
): Promise<CreditNoteInfo> {
    const res = await get(`credit-note/${id}`)

    return parseCreditNote(res.data.data, coins)
}

export async function joinSales(data: JoinSales): Promise<void> {
    await post('sale/join', data, {
        useRecaptcha: true,
    })
}

export async function joinPayments(data: JoinPayments): Promise<void> {
    await post('sale-payment/join', data, {
        useRecaptcha: true,
    })
}

export async function getPixById(id: number): Promise<Pix> {
    const res = await get(`pix/${id}`)
    return res.data.data
}

export async function refundPix(id: number): Promise<void> {
    await post(`pix/refund/${id}`, {})
}

export async function listPix(data: ListPix): Promise<ListReturn<Pix>> {
    const res = await post('pix/list', data)
    return res.data.data
}

export async function getParaguayTransferById(
    id: number
): Promise<ParaguayTransfer> {
    const res = await get(`paraguay-transfer/${id}`)
    return res.data.data
}

export async function fixEletronicNote(data: FixEletronicNote): Promise<void> {
    const res = await post('fix-eletronic-note', data, {
        useRecaptcha: true,
    })
    return res.data.data
}

export async function listSaleContracts(
    data: ListSaleContractsInterface,
    coins: CoinInfo[]
): Promise<ListReturn<SaleContract>> {
    const res = await post('sale-contract/list', data)
    return {
        data: res.data.data.data.map(
            (saleContractApiData: SaleContractApiData) =>
                parseSaleContract(saleContractApiData, coins)
        ),
        count: res.data.data.count,
    }
}

export async function createSaleContract(
    data: CreateSaleContractsInterface
): Promise<void> {
    await post('sale-contract', data)
}

export async function updateSaleProduct(
    data: UpdateSaleProduct
): Promise<void> {
    await put('sale-products', data)
}

export async function createDelivery(
    data: CreateDeliveryInterface
): Promise<void> {
    await post('sale/delivery', data)
}

export async function listDelivery(
    data: ListDeliveryInterface,
    coins: CoinInfo[]
): Promise<ListReturn<DeliveryInfo>> {
    const res = await post('sale/delivery/list', data)
    return {
        data: res.data.data.data.map((data: DeliveryApiData) =>
            parseDelivery(data, coins)
        ),
        count: res.data.data.count,
    }
}

export async function getDeliveryById(
    id: number,
    coins: CoinInfo[]
): Promise<DeliveryInfo> {
    const res = await get(`sale/delivery/${id}`)
    return parseDelivery(res.data.data, coins)
}

export async function refundProductsInDelivery(
    data: RefundProductsInDeliveryInterface
): Promise<void> {
    await post('sale/delivery/refund', data)
}

export async function updateParcel(data: UpdateParcelInterface): Promise<void> {
    await put('sale/parcel', data, {
        useRecaptcha: true,
    })
}

export interface AddParcelInvoiceInterface {
    id_parcela: number
    id_nota: number
    tipo_transacao_fatura?: number
}

export async function addParcelInvoice(
    data: AddParcelInvoiceInterface
): Promise<void> {
    await post('parcel/invoice', data, {
        useRecaptcha: true,
    })
}

export interface FixParcelEletronicNoteInterface {
    id_parcela: number
}

export async function fixParcelEletronicNote(
    data: FixParcelEletronicNoteInterface
): Promise<void> {
    await post('parcel/fix-invoice', data, {
        useRecaptcha: true,
    })
}
